<template>
  <div class="text-caption text-orange-9" data-test="contagem-cancelamento">
    <template v-if="!contagemExpirada">Confirmando o cancelamento · {{ contagemFormatada }}</template>
    <template v-else>O cancelamento ainda não foi confirmado. O sistema segue conferindo.</template>
  </div>
</template>

<script>
import contagemRegressiva from "@/mixins/contagem-regressiva";

export default {
  name: "ContagemCancelamento",
  mixins: [contagemRegressiva],
  props: {
    prazo: { type: String, default: null }
  },
  watch: {
    prazo: {
      immediate: true,
      handler(prazo) {
        this.iniciarContagem(prazo);
      }
    }
  }
};
</script>
